import type { Catalog } from "../../en";

/** Filipino: Meta OAuth callback (/integrations/meta/callback) (mirrors en). */
export const metaCallback: Catalog["deployKnowledge"]["metaCallback"] = {
  title: "Ikonekta ang Facebook Messenger",
  docTitle: "Kinokonekta ang Messenger",
  loading: "Sinusuri ang iyong Facebook sign-in…",
  pickTitle: "Piliin ang iyong Facebook Page",
  pickBody: "Piliin ang Page na sasagutin ng assistant.",
  pagesLabel: "Mga Facebook Page",
  noCategory: "Facebook Page",
  connect: "Ikonekta ang Page",
  connected: "Nakakonekta ang Messenger sa {{page}}",
  back: "Bumalik sa Mga Channel",
  backHome: "Bumalik sa console",
  noPagesTitle: "Walang nahanap na Page",
  noPagesBody: "Walang Page na ibinahagi ng Facebook sa Sagot. Tiyaking may access sa iyong Page ang account na ginamit mo, at markahan ito sa popup ng Facebook.",
  sharedPages_one: "Nagbahagi ang Facebook ng {{count}} Page sa Sagot.",
  sharedPages_other: "Nagbahagi ang Facebook ng {{count}} Page sa Sagot.",
  sharedPagesPartial_one: "Nagbahagi ang Facebook ng {{count}} Page sa Sagot; {{available}} ang puwedeng ikonekta.",
  sharedPagesPartial_other: "Nagbahagi ang Facebook ng {{count}} Page sa Sagot; {{available}} ang puwedeng ikonekta.",
  unavailableTitle_one: "Hindi maikokonekta ang {{count}} ibinahaging Page gamit ang Facebook account na ito",
  unavailableTitle_other: "Hindi maikokonekta ang {{count}} ibinahaging Page gamit ang Facebook account na ito",
  unavailableBody: "Pinayagan ka ng Facebook na tikan ito, pero hindi nito binigyan ang Sagot ng access sa mga mensahe nito. Nangyayari ito kapag naaabot lang ng account mo ang Page sa pamamagitan ng business portfolio. Bigyan ng full control ang iyong Facebook account sa Page (Meta Business Suite → Settings → Pages → ang Page → People), saka piliin muli ang mga Page.",
  unavailableId: "Page ID {{id}}",
  repickTitle: "Hindi makita ang iyong Page?",
  repickBody: "Ibinabahagi lang ng Facebook ang mga Page na tinik mo sa sign-in popup nito, at naaalala nito ang dati mong pinili. Para baguhin ito, buksan ang Facebook → Settings & privacy → Settings → Business integrations, alisin ang app na ito, saka pumili ulit ng mga Page at tikan ang bawat Page (at ang business nito) na gagamitin ng Sagot.",
  repickBusiness: "Ang mga Page na pinamamahalaan sa pamamagitan ng Business portfolio ay lalabas lang kung may access ka sa Page bilang tao, hindi lang sa pamamagitan ng business.",
  repickAction: "Piliin muli ang mga Page",
  missingPermsTitle: "Hindi naibahagi ng Facebook ang lahat ng pahintulot",
  missingPermsBody: "Kailangan ng Sagot ang lahat ng ito para mabasa at masagot ang mga Messenger message sa iyong Page. Ibigay ang mga ito, saka piliin muli ang mga Page.",
  missingPermsList: "Mga kulang na pahintulot",
  notGranted: "Hindi naibigay",
  missingPermsAction: "Ibigay ang mga pahintulot",
  deniedTitle: "Kinansela ang Facebook sign-in",
  deniedBody: "Walang nakonekta. Puwede mong subukan muli mula sa Mga Channel kapag handa ka na.",
  missingTitle: "Nag-expire na ang sign-in link na ito",
  missingBody: "Simulan muli ang pagkonekta mula sa page ng Mga Channel ng assistant na gusto mong ikonekta.",
  failedTitle: "Hindi namin natapos ikonekta ang Messenger",
  failedBody: "Maaaring nag-expire ang sign-in. Magsimula muli mula sa Mga Channel.",
};
